import React from 'react';
import { useAdobeDataLayer, PageNames } from '../../../hooks/useAdobeDataLayer';
import OnPropertyIntro from '../../../components/Redesign/OnPropertyIntro';
import Intro from '../../../components/Redesign/Intro';
import OnPropertyExperience from '../../../components/Redesign/OnPropertyExperience';
import OnPropertyGuestRoom from '../../../components/Redesign/OnPropertyGuestRoom';
import OnPropertyArrivePortal from '../../../components/Redesign/OnPropertyArrivePortal';
import OnPropertyBiggerMoments from '../../../components/Redesign/OnPropertyBiggerMoments';
import SolutionsNavigation from '../../../components/Redesign/SolutionsNavigation';

const OnProperty = () => {
    const { sendPageView } = useAdobeDataLayer();

    React.useEffect(() => {
        sendPageView(PageNames.OnProperty);
    }, [sendPageView]);

    return (
        <div className='on-property-page'>
            <OnPropertyIntro />
            <Intro className="intro-custom-size">
                When travelers arrive, they’re immersed. Your brand meets them in emotions of pause and indulgence. Their attention is undivided and context is real. If your ad can amplify that feeling, there is no interrupting, {' '}
                <span className='audience-pill cs-intro-pill' style={{ '--pill-bg': '#DDF4FF' }}>
                    <span className='cs-lightning-wrapper' style={{ backgroundColor: '#29ABE2' }}>
                        <svg viewBox="0 0 24 24" className="cs-lightning-bolt" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                        </svg>
                    </span>
                    only joining the experience.
                </span>
            </Intro>

            <OnPropertyGuestRoom />
            <OnPropertyArrivePortal />
            <OnPropertyBiggerMoments />
            <SolutionsNavigation
                prevTitle="Marriott Digital"
                prevLink="/solutions/marriott-digital"
                nextTitle="OFFSITE DIGITAL"
                nextLink="/solutions/offsite-digital"
            />

        </div>
    );
};

export default OnProperty;
